export const Routes = {
    root: '/',
    demo: '/demo',
    christmas: '/christmas',
    dsgvo: '/dsgvo',
    imprint: '/imprint'
};